import { getOrgProxyConfigs, getOrgProxyConfigsQueryKey } from '@onefootprint/fetch-dashboard';
import type { GetOrgProxyConfigsData, ProxyConfigBasic } from '@onefootprint/request-types/dashboard';
import { useQuery } from '@tanstack/react-query';

type Filters = {
  isLive?: boolean;
  status?: NonNullable<GetOrgProxyConfigsData['query']>['status'];
};

const PAGE_SIZE = 100;

const requestOptions = ({ isLive, status }: Filters) => ({
  headers: isLive === undefined ? undefined : { 'x-is-live': String(isLive) },
  query: { status, pageSize: PAGE_SIZE },
});

const allProxyConfigsQueryKey = (filters: Filters) => [...getOrgProxyConfigsQueryKey(requestOptions(filters)), 'all'];

const fetchAllProxyConfigs = async (filters: Filters, signal: AbortSignal) => {
  const options = requestOptions(filters);
  const configs: ProxyConfigBasic[] = [];
  let cursor: string | undefined;
  do {
    const { data } = await getOrgProxyConfigs({
      ...options,
      query: { ...options.query, cursor },
      signal,
      throwOnError: true,
    });
    configs.push(...data.data);
    cursor = data.meta.next;
  } while (cursor);
  return configs;
};

// Pickers need every configuration, so this walks the pages instead of showing one.
const useAllProxyConfigs = (filters: Filters = {}, { enabled = true }: { enabled?: boolean } = {}) =>
  useQuery({
    queryKey: allProxyConfigsQueryKey(filters),
    queryFn: ({ signal }) => fetchAllProxyConfigs(filters, signal),
    enabled,
  });

export { allProxyConfigsQueryKey };
export default useAllProxyConfigs;
